module.exports = __webpack_public_path__ + "static/media/Empty Houses.4ddfb34c.jpg";